/**
 * Phase 0 movement tuning, shared by client prediction and server authority.
 * Values are starting points to tune in playtests (GDD §3.5). Speeds and
 * jump are per champion (`FighterKit`, derived from its stats); these are the
 * values of a champion with every stat at 50, and the shared body size.
 */
/** Common pace, including champions with explicit form or summon speed overrides. */
export const MOVEMENT_PACE = { run: 0.75, dash: 0.8 } as const;

export const Movement = {
  /** Fighter collision cylinder. */
  radius: 0.45,
  height: 1.7,

  maxSpeed: 7 * MOVEMENT_PACE.run,
  groundAccel: 70 * MOVEMENT_PACE.run,
  groundDecel: 60,
  airAccel: 30 * MOVEMENT_PACE.run,
  airDecel: 6,
  /** Joystick magnitude below this is treated as no input. */
  deadzone: 0.08,

  gravity: 34,
  /** Faster fall than rise for snappier jumps. */
  fallGravityMultiplier: 1.35,
  maxFallSpeed: 30,
  jumpSpeed: 11.5,
  /** Ticks after walking off a ledge during which a jump still works. */
  coyoteTicks: 4,

  dashSpeed: 17 * MOVEMENT_PACE.dash,
  dashTicks: 6,
  dashCooldownTicks: 24,
} as const;
